import { useSEO } from '@/hooks/useSEO';
import PageNavbar from "@/components/feature/PageNavbar";
import BlogHero from "./components/BlogHero";
import BlogGrid from "./components/BlogGrid";
import Footer from "@/pages/home/components/Footer";

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://isman.co.ke';

const BLOG_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "ISMAN Engineering Blog",
    "url": SITE_URL + "/blog",
    "description": "Engineering insights, industry news and technical guides from ISMAN Engineering Company Kenya — covering HVAC, industrial machinery, automation and water treatment.",
    "publisher": {
      "@type": "Organization",
      "name": "ISMAN Engineering Company",
      "url": SITE_URL
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
      { "@type": "ListItem", "position": 2, "name": "Blog", "item": SITE_URL + "/blog" }
    ]
  }
];

export default function BlogPage() {
  useSEO({
    title: 'Engineering Blog | ISMAN Company Kenya — HVAC, Machinery & Automation Insights',
    description: 'Engineering insights, technical guides and industry news from ISMAN Engineering Company Kenya. Topics cover HVAC, industrial machinery, water treatment and PLC automation.',
    keywords: 'engineering blog Kenya, HVAC tips Kenya, industrial machinery articles, water treatment Kenya, engineering insights Nairobi',
    canonical: SITE_URL + '/blog',
    schema: BLOG_SCHEMA,
  });

  return (
    <main className="min-h-screen">
      <PageNavbar />
      <BlogHero />
      <BlogGrid />
      <Footer />
    </main>
  );
}
